class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this._btn = null;
    this._visible = false;
    this._onScroll = this._onScroll.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this._btn = this.querySelector('button');
    if (!this._btn) return;

    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._btn.addEventListener('click', this._onClick);

    this._onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    if (this._btn) this._btn.removeEventListener('click', this._onClick);
  }

  _onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const showThreshold = viewportHeight;
    const hideThreshold = Math.max(viewportHeight * 0.5, 200);
    const shouldBeVisible = this._visible ? scrollTop > hideThreshold : scrollTop >= showThreshold;
    
    if (shouldBeVisible !== this._visible) {
      this.classList.toggle('active', shouldBeVisible);
      this._visible = shouldBeVisible;
    }
  }

  _onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('scroll-to-top', ScrollToTop);
